import { BusinessPartyTypeEnum } from "../../../store/store.model";
export function getBusinessTriggerSubtext(worksAt) {
  if (!worksAt) {
    return '';
  }
  switch (worksAt.type) {
    case BusinessPartyTypeEnum.Vendor:
      return '';
    case BusinessPartyTypeEnum.Customer:
      return "Client of ".concat(worksAt.customer.vendor.name);
    case BusinessPartyTypeEnum.MultiVendorCustomer:
      return '';
  }
}
export function getBusinessTriggerLogoUrl(worksAt) {
  if (!worksAt) {
    return '';
  }
  switch (worksAt.type) {
    case BusinessPartyTypeEnum.Vendor:
      return worksAt.logoUrl || '';
    case BusinessPartyTypeEnum.Customer:
      return worksAt.customer.vendor.logoUrl || '';
    case BusinessPartyTypeEnum.MultiVendorCustomer:
      return '';
  }
}